export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';
export const USER_DETAILS_RESET = 'USER_DETAILS_RESET';

export const USER_TENANT_ACCESS_REQUEST = 'USER_TENANT_ACCESS_REQUEST';
export const USER_TENANT_ACCESS_SUCCESS = 'USER_TENANT_ACCESS_SUCCESS';
export const USER_TENANT_ACCESS_FAIL = 'USER_TENANT_ACCESS_FAIL';
export const USER_TENANT_ACCESS_RESET = 'USER_TENANT_ACCESS_RESET';


export const USER_TENANCY_REGISTER_REQUEST = 'USER_TENANCY_REGISTER_REQUEST'
export const USER_TENANCY_REGISTER_SUCCESS = 'USER_TENANCY_REGISTER_SUCCESS'
export const USER_TENANCY_REGISTER_FAIL = 'USER_TENANCY_REGISTER_FAIL'


export const USER_UPDATE_TENANCY_PROFILE_REQUEST = 'USER_UPDATE_TENANCY_PROFILE_REQUEST'
export const USER_UPDATE_TENANCY_PROFILE_SUCCESS = 'USER_UPDATE_TENANCY_PROFILE_SUCCESS'
export const USER_UPDATE_TENANCY_PROFILE_FAIL = 'USER_UPDATE_TENANCY_PROFILE_FAIL'
export const USER_UPDATE_TENANCY_PROFILE_RESET = 'USER_UPDATE_TENANCY_PROFILE_RESET'


export const TENANT_DASHBOARD_DETAILS_REQUEST = 'TENANT_DASHBOARD_DETAILS_REQUEST'
export const TENANT_DASHBOARD_DETAILS_SUCCESS = 'TENANT_DASHBOARD_DETAILS_SUCCESS'
export const TENANT_DASHBOARD_DETAILS_FAIL = 'TENANT_DASHBOARD_DETAILS_FAIL'
export const TENANT_DASHBOARD_DETAILS_RESET = 'TENANT_DASHBOARD_DETAILS_RESET'


export const USER_TENANCY_PROFILE_DETAILS_REQUEST = 'USER_TENANCY_PROFILE_DETAILS_REQUEST'
export const USER_TENANCY_PROFILE_DETAILS_SUCCESS = 'USER_TENANCY_PROFILE_DETAILS_SUCCESS'
export const USER_TENANCY_PROFILE_DETAILS_FAIL = 'USER_TENANCY_PROFILE_DETAILS_FAIL'
export const USER_TENANCY_PROFILE_DETAILS_RESET = 'USER_TENANCY_PROFILE_DETAILS_RESET'

export const USER_TENANT_CREATE_REQUEST = 'USER_TENANT_CREATE_REQUEST';
export const USER_TENANT_CREATE_SUCCESS = 'USER_TENANT_CREATE_SUCCESS';
export const USER_TENANT_CREATE_FAIL = 'USER_TENANT_CREATE_FAIL';
export const USER_TENANT_CREATE_RESET = 'USER_TENANT_CREATE_RESET';

export const USER_TENANT_LIST_REQUEST = 'USER_TENANT_LIST_REQUEST'
export const USER_TENANT_LIST_SUCCESS = 'USER_TENANT_LIST_SUCCESS'
export const USER_TENANT_LIST_FAIL = 'USER_TENANT_LIST_FAIL'
export const USER_TENANT_LIST_RESET = 'USER_TENANT_LIST_RESET'

export const USER_LIST_ADMIN_REQUEST = 'USER_LIST_ADMIN_REQUEST'
export const USER_LIST_ADMIN_SUCCESS = 'USER_LIST_ADMIN_SUCCESS'
export const USER_LIST_ADMIN_FAIL = 'USER_LIST_ADMIN_FAIL'
export const USER_LIST_ADMIN_RESET = 'USER_LIST_ADMIN_RESET'

export const TENANT_ANALYTICS_REQUEST = 'TENANT_ANALYTICS_REQUEST'
export const TENANT_ANALYTICS_SUCCESS = 'TENANT_ANALYTICS_SUCCESS'
export const TENANT_ANALYTICS_FAIL = 'TENANT_ANALYTICS_FAIL'
export const TENANT_ANALYTICS_RESET = 'TENANT_ANALYTICS_RESET'

export const TENANT_LOGO_UPLOAD_REQUEST = 'TENANT_LOGO_UPLOAD_REQUEST'
export const TENANT_LOGO_UPLOAD_SUCCESS = 'TENANT_LOGO_UPLOAD_SUCCESS'
export const TENANT_LOGO_UPLOAD_FAIL = 'TENANT_LOGO_UPLOAD_FAIL'
export const TENANT_LOGO_UPLOAD_RESET = 'TENANT_LOGO_UPLOAD_RESET'

export const SECONDARY_LOGO_UPLOAD_REQUEST = 'SECONDARY_LOGO_UPLOAD_REQUEST'
export const SECONDARY_LOGO_UPLOAD_SUCCESS = 'SECONDARY_LOGO_UPLOAD_SUCCESS'
export const SECONDARY_LOGO_UPLOAD_FAIL = 'SECONDARY_LOGO_UPLOAD_FAIL'

export const USER_PERMISSION_UPDATE_REQUEST = 'USER_PERMISSION_UPDATE_REQUEST'
export const USER_PERMISSION_UPDATE_SUCCESS = 'USER_PERMISSION_UPDATE_SUCCESS'
export const USER_PERMISSION_UPDATE_FAIL = 'USER_PERMISSION_UPDATE_FAIL'
export const USER_PERMISSION_UPDATE_RESET = 'USER_PERMISSION_UPDATE_RESET'

export const USER_SUSPEND_REQUEST = 'USER_SUSPEND_REQUEST'
export const USER_SUSPEND_SUCCESS = 'USER_SUSPEND_SUCCESS'
export const USER_SUSPEND_FAIL = 'USER_SUSPEND_FAIL'
export const USER_SUSPEND_RESET = 'USER_SUSPEND_RESET'

export const USER_PASSWORD_RESET_REQUEST = 'USER_PASSWORD_RESET_REQUEST'
export const USER_PASSWORD_RESET_SUCCESS = 'USER_PASSWORD_RESET_SUCCESS'
export const USER_PASSWORD_RESET_FAIL = 'USER_PASSWORD_RESET_FAIL'
export const USER_PASSWORD_RESET_RESET = 'USER_PASSWORD_RESET_RESET'

export const USER_PASSWORD_CHANGE_REQUEST = 'USER_PASSWORD_CHANGE_REQUEST'
export const USER_PASSWORD_CHANGE_SUCCESS = 'USER_PASSWORD_CHANGE_SUCCESS'
export const USER_PASSWORD_CHANGE_FAIL = 'USER_PASSWORD_CHANGE_FAIL'
export const USER_PASSWORD_CHANGE_RESET = 'USER_PASSWORD_CHANGE_RESET'
